import React from 'react';
import { ContentItem } from './style';

function Section({ img, text1, bigText, text2, width }) {
  return (
    <ContentItem>
      <img src={img} alt="imagem" />
      <div>
        <p className="label">{text1}</p>
        <p className="destaque">{bigText}</p>
        <p className="label">{text2}</p>
      </div>
    </ContentItem>
  );
}

export default Section;
